import * as React from 'react';
import { FC } from 'react';

import { Menu, MenuItem } from '@mui/material';
import { Trash2, Edit3, Eye } from 'react-feather';

interface EventActionMenuProps {
  onClickEdit: () => void;
  onClickDelete: () => void;
  onClickView: () => void;
  onClose: () => void;
  open: boolean;
  anchorEl: HTMLElement | null;
}

export const EventActionMenu: FC<EventActionMenuProps> = ({
  onClickEdit,
  onClickDelete,
  onClickView,
  onClose,
  open,
  anchorEl,
}) => {
  return (
    <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={onClose}>
      <MenuItem onClick={onClickEdit} hidden>
        <Edit3 size={16} style={{ marginRight: 10 }} />
        Edit Event
      </MenuItem>

      <MenuItem onClick={onClickDelete}>
        <Trash2 size={16} style={{ marginRight: 10 }} />
        Delete Event
      </MenuItem>
      {false && (
        <MenuItem onClick={onClickView} hidden>
          <Eye size={16} style={{ marginRight: 10 }} />
          View Event
        </MenuItem>
      )}
    </Menu>
  );
};
